import { ApiRequestStore } from '../../../common/apiRequest.store'

class PerformanceSaveStore extends ApiRequestStore {}

export const performanceSaveStore: PerformanceSaveStore = new PerformanceSaveStore()
